module.exports = __webpack_public_path__ + "static/img/del.4896e36b.png";